// extracted by mini-css-extract-plugin
export default {"admission":"Admission_admission__+hao4"};